import dayjs from 'dayjs'
import { createWorker } from 'embed_v2/hooks/useRemainTimeWorker'
import { formatSeconds } from 'core/helpers/formatters'

const formatTime = (scheduledAt?: string) => {
  if (!scheduledAt) return

  return dayjs(scheduledAt).diff(dayjs(), 'seconds')
}

const startTimerFn = (startPosition: number, setSecondsFn: (value: ReturnType<typeof formatSeconds>) => void) => {
  setSecondsFn(formatSeconds(startPosition))

  const worker = createWorker(setSecondsFn)
  worker.postMessage(startPosition)

  return () => {
    worker.terminate()
  }
}

export { startTimerFn, formatTime }
